import { render } from "./StatusIcon.vue?vue&type=template&id=4058ca75"
import script from "./StatusIcon.vue?vue&type=script&lang=js"
export * from "./StatusIcon.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__